import { Link } from "react-router-dom";
import { BRANDS, COMPANY, IMG } from "../data";

export default function OurBrands() {
  return (
    <main data-testid="our-brands-page" style={{ background: "var(--cream)" }}>
      {/* HERO */}
      <section className="pt-40 pb-20 relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage: `url(${IMG.mistyMountains})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>
        <div className="container-cu relative z-10 text-center max-w-3xl mx-auto">
          <p className="eyebrow mb-6">The Portfolio</p>
          <h1 className="heading-display text-5xl sm:text-6xl lg:text-7xl mb-6">
            Our <span className="heading-italic">Brands</span>
          </h1>
          <p className="text-lg leading-relaxed" style={{ color: "var(--brown-soft)" }}>
            Three AI-native platforms. One vision. Built with purpose.
          </p>
          <div className="mt-10 inline-flex items-center gap-2">
            <span className="w-12 h-px" style={{ background: "var(--gold)" }}></span>
            <i className="fa-regular fa-gem text-sm" style={{ color: "var(--gold-deep)" }}></i>
            <span className="w-12 h-px" style={{ background: "var(--gold)" }}></span>
          </div>
        </div>
      </section>

      {/* BRANDS — alternating */}
      {BRANDS.map((b, i) => {
        const reverse = i % 2 === 1;
        return (
          <section
            key={b.id}
            id={b.id}
            className="section"
            data-testid={`brand-section-${b.id}`}
            style={{ background: i % 2 === 0 ? "var(--cream)" : "var(--cream-deep)" }}
          >
            <div className="container-cu grid lg:grid-cols-12 gap-12 items-center">
              <div className={`lg:col-span-7 ${reverse ? "lg:order-2" : ""}`}>
                <div className="flex items-center gap-4 mb-6">
                  {b.logo ? (
                    <img
                      src={b.logo}
                      alt={`${b.name} logo`}
                      className="w-14 h-14 rounded-md object-cover"
                      style={{ background: b.logoBg, border: "1px solid var(--line)" }}
                    />
                  ) : (
                    <span
                      className="w-14 h-14 rounded-md inline-flex items-center justify-center text-xl"
                      style={{ background: "var(--forest)", color: "var(--gold)" }}
                    >
                      <i className={`fa-solid ${b.icon}`}></i>
                    </span>
                  )}
                  <span className={`badge ${b.statusType === "live" ? "badge-live" : "badge-soon"}`}>
                    {b.status}
                  </span>
                </div>
                <h2 className="heading-display text-5xl sm:text-6xl mb-3">{b.name}</h2>
                <p
                  className="text-xs uppercase tracking-[0.24em] mb-8"
                  style={{ color: "var(--gold-deep)" }}
                >
                  {b.tagline}
                </p>
                <p className="text-base leading-relaxed mb-8 max-w-2xl" style={{ color: "var(--brown-soft)" }}>
                  {b.description}
                </p>

                {b.powered && (
                  <div className="mb-6">
                    <p className="eyebrow mb-3">Powered by</p>
                    <div className="flex flex-wrap gap-2">
                      {b.powered.map((p) => (
                        <span
                          key={p}
                          className="text-xs px-3 py-1.5 rounded-full"
                          style={{
                            background: "var(--white)",
                            border: "1px solid var(--line)",
                            color: "var(--forest)",
                          }}
                        >
                          {p}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {b.tiers && (
                  <div className="mb-6">
                    <p className="eyebrow mb-3">Membership tiers</p>
                    <div className="flex flex-wrap gap-2">
                      {b.tiers.map((t) => (
                        <span
                          key={t}
                          className="text-xs px-3 py-1.5 rounded-full font-medium tracking-[0.18em]"
                          style={{
                            background: "var(--white)",
                            border: "1px solid var(--line)",
                            color: "var(--forest)",
                          }}
                        >
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {b.pricing && (
                  <p className="text-sm mb-6" style={{ color: "var(--brown)" }}>
                    <i className="fa-solid fa-tag mr-2" style={{ color: "var(--gold-deep)" }}></i>
                    {b.pricing}
                  </p>
                )}

                {b.contact && (
                  <p className="text-sm mb-6" style={{ color: "var(--brown)" }}>
                    <i className="fa-regular fa-envelope mr-2" style={{ color: "var(--gold-deep)" }}></i>
                    <a href={`mailto:${b.contact}`} className="link-underline">
                      {b.contact}
                    </a>
                  </p>
                )}

                <a
                  data-testid={`brand-visit-${b.id}`}
                  href={b.url}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="btn-primary"
                >
                  {b.cta} <i className="fa-solid fa-arrow-up-right-from-square text-sm"></i>
                </a>
              </div>

              <div className={`lg:col-span-5 ${reverse ? "lg:order-1" : ""}`}>
                {b.logo ? (
                  /* Real logo card — let the logo dominate */
                  <div
                    className="aspect-[4/5] rounded-md overflow-hidden relative flex flex-col items-center justify-center p-10 text-center"
                    style={{ background: b.logoBg }}
                    data-testid={`brand-visual-${b.id}`}
                  >
                    <img
                      src={b.logo}
                      alt={`${b.name} logo`}
                      className="max-w-[80%] max-h-[70%] object-contain"
                    />
                    <div
                      className="absolute bottom-6 left-6 right-6 flex items-center justify-between text-xs uppercase tracking-[0.18em]"
                      style={{ color: "rgba(255,255,255,0.55)" }}
                    >
                      <span>0{i + 1}</span>
                      <span>{b.url.replace(/https?:\/\//, "")}</span>
                    </div>
                  </div>
                ) : (
                  /* GojiDiva — elegant deep pink text placeholder */
                  <div
                    className="aspect-[4/5] rounded-md overflow-hidden relative flex flex-col items-center justify-center p-10 text-center"
                    style={{
                      background: "radial-gradient(ellipse at top, #E91E63 0%, #C2185B 45%, #880E4F 100%)",
                    }}
                    data-testid={`brand-visual-${b.id}`}
                  >
                    <div className="mb-6 opacity-90">
                      <i className="fa-solid fa-heart text-3xl" style={{ color: "rgba(255,255,255,0.85)" }}></i>
                    </div>
                    <p
                      className="font-serif text-5xl sm:text-6xl mb-4 italic"
                      style={{
                        color: "#FFFFFF",
                        textShadow: "0 2px 30px rgba(255,255,255,0.25)",
                        letterSpacing: "-0.01em",
                      }}
                    >
                      {b.name}
                    </p>
                    <p
                      className="text-xs uppercase tracking-[0.3em] mb-4"
                      style={{ color: "rgba(255,255,255,0.85)" }}
                    >
                      {b.tagline}
                    </p>
                    <span
                      className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-[10px] uppercase tracking-[0.2em]"
                      style={{
                        background: "rgba(255,255,255,0.15)",
                        color: "#FFFFFF",
                        border: "1px solid rgba(255,255,255,0.3)",
                      }}
                    >
                      <span className="w-1.5 h-1.5 rounded-full" style={{ background: "#FFFFFF" }}></span>
                      Coming Soon
                    </span>
                    <div
                      className="absolute bottom-6 left-6 right-6 flex items-center justify-between text-xs uppercase tracking-[0.18em]"
                      style={{ color: "rgba(255,255,255,0.55)" }}
                    >
                      <span>0{i + 1}</span>
                      <span>{b.url.replace(/https?:\/\//, "")}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </section>
        );
      })}

      {/* HOLDING STRUCTURE */}
      <section className="section" style={{ background: "var(--brown)" }} data-testid="holding-section">
        <div className="container-cu">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <p className="eyebrow eyebrow-light mb-5" style={{ color: "var(--gold-soft)" }}>
              Holding Structure
            </p>
            <h2
              className="heading-display text-4xl sm:text-5xl mb-6"
              style={{ color: "var(--cream)" }}
            >
              The <span className="heading-italic" style={{ color: "var(--gold)" }}>Casa Haya</span> Family
            </h2>
            <p className="text-base" style={{ color: "rgba(250,247,242,0.8)" }}>
              One holding. One mission. Three platforms.
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            <div
              className="rounded-md p-6 mb-3 text-center"
              style={{
                background: "var(--forest)",
                color: "var(--cream)",
                border: "1px solid var(--gold)",
              }}
            >
              <p className="text-xs uppercase tracking-[0.22em] mb-1" style={{ color: "var(--gold-soft)" }}>
                Operational Company · KvK {COMPANY.kvk}
              </p>
              <p className="heading-display text-2xl" style={{ color: "var(--cream)" }}>{COMPANY.name}</p>
            </div>

            <div className="flex justify-center">
              <div className="w-px h-8" style={{ background: "rgba(250,247,242,0.4)" }}></div>
            </div>

            <div className="grid sm:grid-cols-3 gap-4">
              {BRANDS.map((b) => (
                <div
                  key={b.id}
                  className="rounded-md p-5 text-center"
                  style={{
                    background: "rgba(250,247,242,0.06)",
                    border: "1px solid rgba(250,247,242,0.16)",
                    color: "var(--cream)",
                  }}
                >
                  {b.logo ? (
                    <img
                      src={b.logo}
                      alt={`${b.name} logo`}
                      className="w-10 h-10 mb-3 mx-auto rounded object-cover"
                      style={{ background: b.logoBg }}
                    />
                  ) : (
                    <div
                      className="w-10 h-10 mb-3 mx-auto rounded flex items-center justify-center"
                      style={{ background: "#C2185B" }}
                    >
                      <i className="fa-solid fa-heart text-sm" style={{ color: "#FFFFFF" }}></i>
                    </div>
                  )}
                  <p className="font-serif text-lg">{b.name}</p>
                  <p className="text-[11px] uppercase tracking-[0.18em] opacity-70 mt-1">
                    {b.tagline.replace("Premium ", "").replace("The Next-Gen ", "").replace("Your ", "")}
                  </p>
                  <p className="text-[11px] mt-2 opacity-60">{b.url.replace(/https?:\/\//, "")}</p>
                </div>
              ))}
            </div>

            <p
              className="text-center mt-12 max-w-xl mx-auto text-sm leading-relaxed"
              style={{ color: "rgba(250,247,242,0.75)" }}
            >
              All brands are owned and operated under {COMPANY.name}, a
              Dutch-registered company (KvK: {COMPANY.kvk}).
            </p>
          </div>
        </div>
      </section>

      {/* INVEST CTA */}
      <section className="section" data-testid="invest-cta">
        <div className="container-narrow text-center">
          <p className="eyebrow mb-5">Partners & Investors</p>
          <h2 className="heading-display text-4xl sm:text-5xl mb-6">
            Interested in <span className="heading-italic">partnering or investing?</span>
          </h2>
          <p className="text-base leading-relaxed max-w-xl mx-auto mb-10" style={{ color: "var(--brown-soft)" }}>
            We are currently seeking{" "}
            <span className="font-medium" style={{ color: "var(--forest)" }}>€1M – €1.5M</span> in
            growth funding via a profit sharing model.{" "}
            <span style={{ color: "var(--gold-deep)" }}>No equity transfer.</span>
          </p>
          <a
            data-testid="invest-contact-cta"
            href={`mailto:${COMPANY.email}`}
            className="btn-primary"
          >
            Get in Touch <i className="fa-solid fa-arrow-right text-sm"></i>
          </a>
          <p className="mt-6 text-sm" style={{ color: "var(--brown-soft)" }}>
            or write directly to{" "}
            <a href={`mailto:${COMPANY.email}`} className="link-underline" style={{ color: "var(--forest)" }}>
              {COMPANY.email}
            </a>
          </p>
        </div>
      </section>
    </main>
  );
}
